export const sortTopologies = ({
  topologies,
}: TopologiesQueryResponse): Topology[] =>
  topologies.sort(
    (a, b) =>
      new Date(b.lastUpdated).getTime() - new Date(a.lastUpdated).getTime(),
  );
